import React from 'react';
import PropTypes from 'prop-types';
import Skeleton from 'wsm-skeleton';

import './Skeleton.scss';

/* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/interactive-supports-focus */
const PaginationSkeleton = ({ isMobile = false }) => {
	const HaveViewedSkeleton = () => <Skeleton width='22px' height={isMobile ? '18px' : '20px'} skeletonClasses='mx-2 rounded' />;
	return (
		<div className='mt-4' aria-hidden="true">
			<div className='mb-3 text-center'>
				<span className='text-muted d-flex justify-content-center align-items-center'>
					You have viewed <HaveViewedSkeleton /> of <HaveViewedSkeleton /> results  
				</span>
			</div>

			{/* Pagination component - only show when more than 1 page */}
			<nav aria-label='Page navigation'>
				<ul className='pagination d-flex justify-content-center align-items-center'>
					{/* Previous button */}
					<li className='pagination-previous disabled'>
						<a type='button'>
							<i className='ddc-icon ddc-icon-skinny-arrow-left' />
						</a>
					</li>
					<li className='active'>
						<a type='button'>1</a>
					</li>
					<li>
						<a type='button'>2</a>
					</li>
					<li>
						<a type='button'>3</a>
					</li>
					<li>
						<a type='button'>4</a>
					</li>
					<li className='pagination-ellipsis'>
						<span>…</span>
					</li>
					<li>
						<Skeleton width='2.5em' circle />
					</li>

					{/* Next button */}
					<li className='pagination-next disabled'>
						<a type='button'>
							<i className='ddc-icon ddc-icon-skinny-arrow-right' />
						</a>
					</li>
				</ul>
			</nav>
		</div>
	);
};

export default PaginationSkeleton;

PaginationSkeleton.propTypes = {
	isMobile: PropTypes.bool,
};